import { ModelStatus } from './enum'

export let ConverterSummary = {
  type: '',
  id: '',
  name: '',
  option: {},
  hyperParams: []
}

export let ConvertersCategory = {
  label: '',
  categoryId: '',
  data: []
}

export let ConvertResultPreviewResult = {
  id: '',
  value: []
}

export let ConvertResultPreview = {
  idName: '',
  header: [],
  results: []
}

export let ConvertResult = {
  converter: '',
  resultFile: '',
  resultPreview: ConvertResultPreview,
  resultCount: Number,
  updatedAt: ''
}

export let ConvertResultListValue = {
  taskId: '',
  converterId: '',
  converterName: '',
  key: '',
  updatedAt: '',
  count: Number,
  statusCode: ModelStatus,
  resultFile: ''
}

export const ConverterHyperParams = {
  FaceImage: [],

  HandwriteImage: [],

  KMeans: [
    {
      'hyperParamId': 'return_distance',
      'hyperParamName': 'クラスタの中心からの距離',
      'defaultVal': '1'
    }, {
      'hyperParamId': 'clusters',
      'hyperParamName': 'クラスタの数',
      'defaultVal': '4'
    }, {
      'hyperParamId': 'try_count',
      'hyperParamName': '試行回数',
      'defaultVal': '3'
    }, {
      'hyperParamId': 'max_iter',
      'tipId': 'max_iter2',
      'hyperParamName': '最大反復数',
      'defaultVal': '300'
    }, {
      'hyperParamId': 'to_be_dummy',
      'hyperParamName': '結果のダミー変数化',
      'defaultVal': '0'
    }, {
      'hyperParamId': 'seed',
      'hyperParamName': '乱数シード',
      'defaultVal': '1'
    }],

  PCA: [
    {
      'hyperParamId': 'components',
      'tipId': 'components1',
      'hyperParamName': '主成分の数',
      'defaultVal': null
    }, {
      'hyperParamId': 'whiten',
      'hyperParamName': '白色化',
      'defaultVal': '0'
    }, {
      'hyperParamId': 'contribution_threshold',
      'hyperParamName': '寄与率の閾値',
      'defaultVal': '0.95'
    }],

  Anomaly: [
    {
      'hyperParamId': 'estimators',
      'tipId': 'estimators_c',
      'hyperParamName': '木の数',
      'defaultVal': '50'
    }, {
      'hyperParamId': 'prop_of_outlier',
      'hyperParamName': '異常値発生率',
      'defaultVal': '0.01'
    }, {
      'hyperParamId': 'seed',
      'hyperParamName': '乱数シード',
      'defaultVal': '1'
    }],

  Dummy: [
    {
      'hyperParamId': 'ignore_too_many',
      'hyperParamName': 'データ種類数の上限',
      'defaultVal': '30'
    }],

  SVD: [
    {
      'hyperParamId': 'components',
      'tipId': 'components2',
      'hyperParamName': '特異値の数',
      'defaultVal': null
    }, {
      'hyperParamId': 'iterations',
      'hyperParamName': '反復数',
      'defaultVal': '5'
    }, {
      'hyperParamId': 'contribution_threshold',
      'hyperParamName': '寄与率の閾値',
      'defaultVal': '0.95'
    }, {
      'hyperParamId': 'seed',
      'hyperParamName': '乱数シード',
      'defaultVal': '1'
    }],

  ICA: [
    {
      'hyperParamId': 'whiten',
      'hyperParamName': '白色化',
      'defaultVal': '1'
    }, {
      'hyperParamId': 'components',
      'tipId': 'components3',
      'hyperParamName': '独立成分の数',
      'defaultVal': null
    }, {
      'hyperParamId': 'max_iter',
      'tipId': 'max_iter3',
      'hyperParamName': '最大反復数',
      'defaultVal': '300'
    }, {
      'hyperParamId': 'seed',
      'hyperParamName': '乱数シード',
      'defaultVal': '1'
    }],

  OneHot: [
    {
      'hyperParamId': 'main_pos',
      'hyperParamName': '主要品詞に限定する',
      'defaultVal': '1'
    }, {
      'hyperParamId': 'max_words_count',
      'hyperParamName': '単語数の上限(出現率の降順)',
      'defaultVal': '100'
    }, {
      'hyperParamId': 'stop_words',
      'hyperParamName': '除外単語',
      'defaultVal': null
    }],

  BoW: [
    {
      'hyperParamId': 'main_pos',
      'hyperParamName': '主要品詞に限定する',
      'defaultVal': '1'
    }, {
      'hyperParamId': 'max_words_count',
      'hyperParamName': '単語数の上限(出現率の降順)',
      'defaultVal': '100'
    }, {
      'hyperParamId': 'stop_words',
      'hyperParamName': '除外単語',
      'defaultVal': null
    }],

  TFIDF: [
    {
      'hyperParamId': 'main_pos',
      'hyperParamName': '主要品詞に限定する',
      'defaultVal': '1'
    }, {
      'hyperParamId': 'max_words_count',
      'hyperParamName': '単語数の上限(出現率の降順)',
      'defaultVal': '100'
    }, {
      'hyperParamId': 'stop_words',
      'hyperParamName': '除外単語',
      'defaultVal': null
    }],

  NP: [
    {
      'hyperParamId': 'main_pos',
      'hyperParamName': '主要品詞に限定する',
      'defaultVal': '1'
    }, {
      'hyperParamId': 'max_words_count',
      'hyperParamName': '単語数の上限(出現率の降順)',
      'defaultVal': '100'
    }, {
      'hyperParamId': 'stop_words',
      'hyperParamName': '除外単語',
      'defaultVal': null
    }],

  Text2Vec: [
    {
      'hyperParamId': 'stop_words',
      'hyperParamName': '除外単語',
      'defaultVal': null
    }],

  SCDV: [
    {
      'hyperParamId': 'stop_words',
      'hyperParamName': '除外単語',
      'defaultVal': null
    }]
}

export const ConverterTip = {
  FaceImageRek: 'ディープラーニング技術を活用し、顔写真から、年齢や性別、ひげの有無や推定される感情など、15個の項目を推定し、数値化します。',

  HandwriteImage: '画像解析技術を活用し、筆跡写真から、直線の割合や文字の傾き、\n平均的な文字との差分スコアなど、13個の項目を評価し、数値化します。',

  Picture: 'ファイルに保存された写真情報や、画像の持つ色の特徴を抽出し、数値化します。',

  KMeans: 'k-meansと呼ばれる手法を用いて、データを指定したクラスタ(＝グループ)に分割します。\nマーケティング等において、クラスタ毎のデモグラフィックを作るなどに活用されます。\n他にも、クラスタリングの結果を属性の1つとしてモデル作成に応用することもあります。',

  PCA: 'データを、主成分と呼ばれる統計的に意味のあるデータ項目に変換します。\n\
            主成分毎に、全体の何％に相当する情報量を持つかを示すのが寄与率であり、\n\
            その累積に対して、閾値を指定することで、情報量を落とさず、項目数を減らすことができます。\n\
            ただし、主成分にすると、項目の意味が分からなくなることに注意が必要です。',

  Anomaly: 'IsolationForestと呼ばれる手法を用いて、全体の中から異常なデータを抽出します。\n\
                これをスコア化し、異常値である度合いを示したのが異常値スコアリングです。\n\
                大多数の通常データとの違いが大きいものを検出するため、不正検知などに活用されます。',

  BoW: '文章を、形態素と呼ばれる単位(主に品詞単位)に分割し、その出現回数を返却します。\n\
            名詞、動詞、形容詞、形容動詞、連体詞、副詞を主要品詞とし、出力結果をこれらに絞ることで、分析が容易になります。',

  TFIDF: '文章を、形態素と呼ばれる単位(主に品詞単位)に分割し、その出現回数と文章全体での出現回数との比を返却します。\n\
            単に出現回数が返却されるのと異なり、全体的に出現頻度の高いものは値が小さくなります。',

  NP: '文章を単語単位に分割し、単語毎に定められたポジティブ/ネガティブの度合いを示す辞書をもとに、スコアを計算します。\n\
            ポジティブな単語/文章はプラス、ネガティブな単語/文章はマイナスの値となります。',

  Dummy: 'コード値など、カテゴリで表されるデータは、そのままでは多くの機械学習アルゴリズムで使用できません。\n\
                そこで、ダミー変数化と呼ばれる処理を行なうことで、数値に変換します。\n\
                例えば、項目XがA、B、Cの値を持つ場合、項目X_A、X_B、X_Cの3つが作られ。Aであれば、X_A=1、X_B=0、X_C=0となります。',

  SVD: 'データを、特異値と呼ばれる統計的に特徴のあるデータ項目に変換します。\n\
            特異値毎に、全体の何％に相当する特徴量を持つかを示すのが寄与率であり、\n\
            その累積に対して、閾値を指定することで、特徴量を落とさずにデータ項目数を減らすことができます。\n\
            ただし、特異値に変換すると、変換後の項目の意味が分からなくなることに注意が必要です。',

  ICA: 'データを、統計的に独立なデータ項目に変換します。\n\
            「独立」とは、確率的に互いに関係ないことを表します。\n\
            元のデータ項目より少ない独立成分の数を指定することで、元のデータから特に有用な成分を抽出することができます。\n\
            ただし、独立成分に変換すると、変換後の項目の意味が分からなくなることに注意が必要です。',

  OneHot: '文章を、形態素と呼ばれる単位(主に品詞単位)に分割し、その出現有無を0/1で表現します。\n\
                名詞、動詞、形容詞、形容動詞、連体詞、副詞を主要品詞とし、出力結果をこれらに絞ることで、分析が容易になります。',

  Text2Vec: '文章を形態素と呼ばれる単位(主に品詞単位)に分割し、潜在的に形態素の意味を表すと言われる高次元のベクトル表現に変換します。\n\
                それぞれの単語ごとのベクトルの平均値を文章全体のベクトルとして返却します。',

  SCDV: '文章を形態素と呼ばれる単位(主に品詞単位)に分割し、潜在的に形態素の意味を表すと言われる高次元のベクトル表現に変換します。\n\
                さらに単語の出現確率や類似度を加味した値を文章全体のベクトルとして返却します。',

}

export const ConverterHyperParamTip = {
  seed: 'モデル作成時に使用するデータの組合せ等を、固定化したい場合などは、この値を設定してください。\n\n\
            処理によっては、作為的な偏りを排除するため、「乱数」を使っております。\n\
            例えば、同じデータ、同じアルゴリズムを使用していても、学習に用いるデータを毎回ランダムに選定します。\n\
            この値によって、「乱数」を固定することが可能になります。',

  regularize: '影響の小さいデータ項目の作用を抑える仕組みです。\n\
                    過学習や多重共線性の問題を回避します。\n\
                    L1：影響の小さいデータ項目は使用しません\n\
                    L2：影響の小さいデータ項目の係数を非常に小さくします\n\
                    一般的には、データ項目数が多い場合は、L1を採用するのが良いです。',

  penalty: '正則化の効果の度合いを示します。\n\
                数値が小さいほど強く作用し、大きいほど弱く作用しますので、注意が必要です。\n\
                一般的には、データ項目数が多い場合は、強め(0.3以下)の値にすると良いです。',

  dt_criterion: '木を分岐させる際に基準とする評価指標です。\n\
                    gini：ジニ不純度\n\
                    entropy：エントロピー',

  features_split: '分岐の条件を選択する際に確認するデータ項目の数を示します。\n\
                      未入力の場合は、全てのデータ項目を確認します。\n\
                      一般的には、未入力で構いません。',

  depth: '生成する決定木の深さの上限値です。\n\
            深い方がモデルの精度は上がる一方で、過学習し易くなりますので、「分岐の下限サンプル数」と併せて調整が必要です。',

  leaf_samples: '学習データの数がこの数を下回ると分岐を行わないようにします。\n\
                    特定のデータに依らないように一定の数を下限とする方がよいモデルとなります。\n\
                    「木の深さ」と併せて調整が必要です。',

  kn_neighbors: '分類するクラスを判定する際に参照する周辺データの数です。\n\
                    少ないと、構成されるクラスタがいびつになり、過学習し易いですが、多き過ぎると平均化され、精度が下がります。',

  kn_algorithm: '周辺データとの"近さ"の選択基準です。\n\
                    "ball_tree"や"kd_tree"などの木系の方法を用いる場合は、「セグメントの下限サンプル数」を調整してください。',

  kn_leaf_size: '"ball_tree"や"kd_tree"などの木系の方法を用いる場合に構成する際の条件です。\n\
                    小さいと別のデータに対しての適合率が下がるので、デフォルト値以上にすることを推奨します。',

  kernel: 'アルゴリズム内で使用されるカーネル関数のタイプです。一般にRBFが使用されます。\n\
                Linear：線形関数\n\
                Poly：多項式関数\n\
                RBF：動径基底関数(ガウシアンカーネル)\n\
                Sigmoid：シグモイド関数\n\
                Precomputed：データから事前計算',

  sv_degree: '「カーネル関数」に"poly"を選択した場合に設定する、多項式の次数です。\n\
                次数が大きいほど学習データに対する精度は向上しますが、過学習し易いので注意が必要です。',

  sv_gamma: '「カーネル関数」に"poly","rbf","sigmoid"を選択した場合に設定します。\n\
                値が大きいほど複雑なデータ構造に対応するようになります。\n\
                ペナルティ値との関係が強く、ペナルティ値に合わせた調整が必要です。',

  smooth: '学習データに存在しないパターンのときに、分類する確率が0となるのを防ぐための数値です。\n\
                データが少ない場合には設定する方が良いですが、十分なデータがあれば0でも構いません。',

  estimators: '生成する木の数です。\n\
                  一般に数が多いほど精度は上がりますが、精度の向上が頭打ちになる一方で計算時間は増え続けるため、適度に抑える必要があります。',

  learning_rate: 'モデルの学習を進めるスピードです。\n\
                    一般に値が小さい程、スピードは遅くなりますが、きめ細かく学習するため、精度は向上します。\n\
                    一方で、多くの木を必要とし、計算時間が長くなります。また、過学習に対する注意も必要です。',

  fit_intercept: 'データの値に依らない定数を持つかどうかを表します。\n\
                        一般的には、切片あり(＝定数あり)とします。',

  l1_ratio: 'ペナルティは、L1、L2という2つの種類があります。\n\
                L1：影響の小さいデータ項目は使用しないように作用します\n\
                L2：影響の小さいデータ項目の係数を非常に小さくするように作用します\n\
                L1/L2比率は、L1とL2を適用する比率を示します。\n\
                1ならL1だけを、0ならL2だけを使用します。\n\
                一般的には、データ項目数が多い場合は、L1が強く作用するように1に近い値をするのが良いです。',

  high_level: '高度なパラメータを設定する場合は、\n\
                  ・ブースティングタイプ\n\
                  ・L1正則化\n\
                  ・L2正則化\n\
                  の3つのオプションを追加で指定できます。',

  num_leaves: '学習データの数がこの数を下回ると分岐を行わないようにします。\n\
                  特定のデータに依らないように一定の数を下限とする方がよいモデルとなります。\n\
                  「木の深さ」と併せて調整が必要です。',

  boosting_type: '木を作成していく際の方法です。\n\
                     一般的に使用されるのはGBDTですが、DARTの方が高精度と言われています。\n\
                     ・GBDT：通常の勾配ブースティング\n\
                     ・DART：一定の割合で生成した木を使わずに学習する手法',

  alpha: '影響の小さいデータ項目の作用を抑える仕組みです。\n\
             過学習を回避します。\n\
             この値が大きいと、影響の小さいデータ項目は使用しない作用が強くなります。\n\
             一般的には、データ項目数が多い場合は、強め(0.5以上)の値にすると良いです。',

  lambda_opt: '影響の小さいデータ項目の作用を抑える仕組みです。\n\
                  過学習を回避します。\n\
                  この値が大きいと、影響の小さいデータ項目の係数を小さくする作用が強くなります。\n\
                  一般的には、データ項目数が多くない場合に使用することが多いです。',

  n_hidden_layer: 'ニューラルネットワークの深さです。\n\
                      隠れ層が2以上のものをディープラーニングと呼び、一般に精度は向上しますが、ユニット数など他の設定内容に大きく依存するため、調整が必要です。',

  n_units: 'ネットワークを構成する要素の数です。\n\
               必ずしも多い程良いという訳ではなく、データや項目数、隣合う隠れ層のユニット数などが複合的に影響するため、調整が必要です。',

  batch_size: '1回の計算で用いるデータ量です。\n\
                  小さいほど計算する回数が増えるため、学習は安定的に進みますが、その分計算時間を必要としますので、適度なサイズに抑えるのが良いです。',

  epoch: '計算処理の単位です。\n\
             1回の計算はバッチサイズで指定したデータ数毎に行いますが、それを繰り返し全データで1回学習することをエポックと呼びます。\n\
             エポック数が大きい程、計算を繰り返すため学習が進み、精度に貢献します。\n\
             一方で、処理時間はかかるため、適度に抑える方が良いです。',

  drop_ratio: 'ランダムに学習しないユニットを選択することで過学習を抑える手法で、「ドロップ率」は学習しないユニットの割合を表します。\n\
                  0の時、すべてのユニットが毎回学習します。\n\
                  一般に、少し学習しないユニットがある方が精度が上がります。',

  optimizer: 'モデルを最適化していく際に使用される手法です。一般にAdamが使用されます。\n\
                 Adam：モーメント推定適応法\n\
                 AdaGrad：勾配適応法\n\
                 SGD：確率的勾配降下法\n\
                 Momentum：モーメント法',

  m_alpha: '「最適化手法」にMomentumを選択した場合に設定します。\n\
               Momentumのロジック内で使われる係数です。',

  beta: '「最適化手法」にAdamを選択した場合に設定します。\n\
             Adamのロジック内で使われる係数です。',

  return_distance: 'データ毎に、それぞれのデータが属するクラスタの中心からの距離を出力するかどうかを表します。',

  clusters: '形成するクラスタ（＝グループ）の数を指定します。',

  try_count: 'クラスタリングでは、最初にクラスタをランダムに配置するため、形成されるクラスタの良し悪しが偶然性に左右されることがあります。\n\
                 試行回数を設定することで、指定した回数だけ試行し、その中でもっとも良い結果クラスタリング結果を返します。',

  to_be_dummy: 'クラスタリングした結果の各データには、クラスタ名が自動的に追加されます。\n\
                   「する」の場合、クラスタ名がダミー変数化された結果が返却されます。\n\
                   不明な場合は、「しない」のままで構いません。',

  ignore_too_many: 'ダミー変数化するとデータ項目に含まれる値の種類数に応じて、項目が増えてしまうため、変換する上限数を指定することを推奨します。',

  components1: '変換後の主成分の数を指定します。\n\
                   元々のデータ項目数を超えた数にはできません。\n\
                   一般的には、主成分の数より寄与率の閾値で制限することが多いです。',

  components2: '変換後の特異値の数を指定します。\n\
                   元々のデータ項目数を超えた数にはできません。\n\
                   一般的には、特異値の数より寄与率の閾値で制限することが多いです。',

  components3: '変換後の独立成分の数を指定します。\n\
                   元々のデータ項目数を超えた数にはできません。\n\
                   一般的には、特異値の数より寄与率の閾値で制限することが多いです。',

  whiten: '変換後のデータについて、平均=0、分散=1となるように変換することを表します。\n\
              後続の処理次第ですが、特に必要ないことが多いです。',

  contribution_threshold: '元のデータの何％の情報量を維持したいかの閾値を指定します。\n\
                              一般に0.95(=95%)以上を指定することが多いです。',

  iterations: '特異値分解では、所定の処理を繰り返し実行して、特異値に近づけていきます。\n\
                  反復数を指定することで、処理時間がかかりすぎるのを防ぐことができます。',

  estimators_c: '異常値を算出するために、生成する木(データを推定する仕組み)の数を指定します。\n\
                    一般に数が多いほど精度は上がりますが、精度の向上が頭打ちになる一方で計算時間は増え続けるため、適度に抑える必要があります。',

  prop_of_outlier: '異常値と判定するための閾値を示します。',

  main_pos: '名詞、動詞、形容詞、形容動詞、連体詞、副詞の6品詞に限定して出力するかどうかを表します。',

  max_words_count: '分解する単語数の上限値を表します。\n\
                       これを超える単語数が存在する場合は、出現回数順の多い単語が選択されます。',

  stop_words: '分解後の単語から除外する単語を指定します。',

  max_iter1: '反復計算する回数の最大値です。\n\
                Noneは制限なしです。\n\
                反復回数が多いほど精度は向上しますが、処理時間がかかります。',

  max_iter2: 'クラスタの形成では、所定の処理を繰り返し実行していきます。\n\
                 最大反復回数を指定することで、処理時間がかかりすぎるのを防ぐことができます。\n\
                一般的に、300回で十分です。',

  max_iter3: '独立成分の抽出では、所定の処理を繰り返し実行していきます。\n\
                  最大反復回数を指定することで、処理時間がかかりすぎるのを防ぐことができます。\n\
                  一般的には、指定なし(＝300回)で問題ありません。'

}



// WEBPACK FOOTER //
// ./src/defines/convert.js